// extracted by mini-css-extract-plugin
export var smallSpinner = "_qo-0";